import React from "react";
import { useStaticQuery, graphql } from "gatsby";

// Styles //
import "./requirementCard.scss";

interface RequirementCardProps {
    description: { json: any };
    useCheckIcon: boolean;
}

const RequirementCard = (props: RequirementCardProps) => {
    const {
        description,
        useCheckIcon
    } = props;
    
    const icons = useStaticQuery(graphql`
        query requirementsIcons {
            iconCheckForList: contentfulAsset(
            contentful_id: {eq: "6qb6CZUbTwNuEPe3c8QCrj"})
            {
                description
                file {
                    url
                }
            }
        }
    `);

    const checkIcon = icons.iconCheckForList;
    
    return (
        <div className="m-requirement-card">
            <div className="m-requirement-card__content">
                {useCheckIcon && (
                    <div className="m-requirement-card__content__image">
                        <img src={checkIcon.file.url} alt={checkIcon.description} />
                    </div>
                )}
                <>{description}</>
            </div>
        </div>
    );
};

export default RequirementCard;
